const timeUnitParamMap: Record<string, string> = {
  "customer acquisition cost": "timeUnitCac",
  "Impression Share": "timeUnitImp",
  "cost per click": "timeUnitCpc",
  "Click In": "timeUnitCi",
  "Click Out": "timeUnitCo",
  "Click Out/In Ratio": "timeUnitCoi",
  "Earn Per Click": "timeUnitEpc",
  "Funnel Ratio": "timeUnitFr",
  "cost per acquisition": "timeUnitCpa",
  "cost per acquisition player value": "timeUnitCpapv",
  "Average Cost Per Acquisition Deal": "timeUnitAcpa",
  "Conversion Rate": "timeUnitCr",
  "First Time Deposit": "timeUnitFtd",
  "Gap Between First Time Deposit and Qualified First Time Deposit":
    "timeUnitGftdqftd",
  "Profit and First Time Deposit": "timeUnitPftd",
  "Player Value": "timeUnitPv",
  "Net Revenue Per First-Time Depositor": "timeUnitNrpf",
  Profit: "timeUnitP",
  Spent: "timeUnitS",
  "Total Income": "timeUnitTi",
  "Revenue Share": "timeUnitRs",
  "Revenue Share Player Value": "timeUnitRspv",
  "Average Revenue Share Percentage Deal": "timeUnitArspd",
};

export default timeUnitParamMap;
